import React, { forwardRef, useEffect, useRef } from 'react';
import { initValue } from '../../utils';

const useFunction = ({ pageSize, containerRef, allData, nextPageCall }) => {
  let isLoading = false;
  const PAGESIZE = pageSize ?? 1;

  const scrollListener = async () => {
    const { current } = containerRef;
    if (current.scrollHeight - current.scrollTop <= current.clientHeight + 2 && !isLoading) {
      isLoading = true;
      const pageNo = parseInt(allData.length / PAGESIZE + 1);
      nextPageCall && (await nextPageCall(PAGESIZE, pageNo));
      isLoading = false;
    }
  };

  const initRefresh = async () => {
    const elem = containerRef.current.querySelector('.MuiTableBody-root');
    const bottom = 100;
    if (Array.isArray(allData) && elem.scrollHeight < containerRef.current.clientHeight + bottom && !isLoading) {
      isLoading = true;
      const pageNo = parseInt(allData.length / PAGESIZE + 1);
      try {
        nextPageCall && (await nextPageCall(PAGESIZE, pageNo));
      } catch {}
      isLoading = false;
    }
  };

  return { initRefresh, scrollListener };
};

export default forwardRef(function PageList(
  { nextPageCall, hideIndex, setHideIndex, children, allData, pageSize, className },
  ref
) {
  const tempRef = useRef(null);
  const containerRef = initValue(ref, tempRef);
  const { initRefresh, scrollListener } = useFunction({ pageSize, containerRef, allData, nextPageCall });

  useEffect(() => {
    if (nextPageCall) {
      const resizeHandle = () => {
        (async () => {
          await initRefresh();
        })();
      };

      const current = containerRef.current;
      const nextPageCtr = () => {
        current.addEventListener('scroll', scrollListener);
        window.addEventListener('resize', resizeHandle);
      };
      nextPageCtr();
      (async () => {
        await initRefresh();
      })();
      return () => {
        current.removeEventListener('scroll', scrollListener);
        window.removeEventListener('resize', resizeHandle);
      };
    }
  }, [allData]);

  useEffect(() => {
    let timeId = null;
    let elem = null;
    if (hideIndex !== null && hideIndex !== undefined && hideIndex > -1) {
      elem = containerRef.current.querySelector('.MuiTableBody-root').children[hideIndex];
      if (elem) {
        elem.style.backgroundColor = '#f5faff';
        timeId = setTimeout(() => {
          const elem = containerRef.current.querySelector('.MuiTableBody-root').children[hideIndex];
          elem.style.backgroundColor = '#fff';
          setHideIndex?.(null);
        }, 3000);
      }
    }
    return () => {
      timeId && clearTimeout(timeId);
      elem && (elem.style.backgroundColor = '#fff');
    };
  }, [hideIndex]);

  const inJectChildren = () => {
    if (children?.length > 0) {
      const newChildren = [...children];
      const temp = React.cloneElement(children[0], { key: 0, ref: containerRef });
      newChildren[0] = temp;
      return newChildren;
    }
    return null;
  };

  return className ? (
    <div ref={containerRef} className={className}>
      {children}
    </div>
  ) : (
    <>{inJectChildren()}</>
  );
});
